"use client";

import React, { type Dispatch, type ReactNode, type SetStateAction, createContext } from "react";
import { useTheme } from "next-themes";
import { Toaster } from "sonner";
import useLocalStorage from "@/hooks/use-local-storage";
import {HeroUIProvider} from "@heroui/react";
import {ThemeProvider as NextThemesProvider} from "next-themes";
import type {SessionValidationResult} from "@/lib/session";
import {SessionProvider} from "@/components/providers/session-provider";

export const AppContext = createContext<{
  font: string;
  setFont: Dispatch<SetStateAction<string>>;
}>({
  font: "Default",
  setFont: () => {},
});

const ToasterProvider = () => {
  const { theme } = useTheme() as {
    theme: "light" | "dark" | "system";
  };
  return <Toaster theme={theme} />;
};

export default function Providers({ children, session }: { children: ReactNode, session: SessionValidationResult}) {
  const [font, setFont] = useLocalStorage<string>("novel__font", "Default");

  return (
      <HeroUIProvider>
          <NextThemesProvider attribute="class" defaultTheme="light">
              <SessionProvider sessionData={session}>
                  <AppContext.Provider
                    value={{
                      font,
                      setFont,
                    }}
                  >
                    <ToasterProvider />
                    {children}
                  </AppContext.Provider>
              </SessionProvider>
          </NextThemesProvider>
      </HeroUIProvider>
  );
}
